import { useCallback, useEffect, useRef } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import {
  setDimensions,
  DimensionsKey,
  selectDimensions,
  removeDimensions,
} from '../state/layout';
import useDispatch from '../state/useDispatch';

const useViewDimensions = <T extends View>(key: DimensionsKey) => {
  const dispatch = useDispatch();
  const ref = useRef<T>(null);
  const dimensions = useSelector(selectDimensions(key));

  const onLayout = useCallback(() => {
    if (ref.current) {
      ref.current.measureInWindow((x, y, width, height) => {
        dispatch(setDimensions([key, { x, y, width, height }]));
      });
    }
  }, [key, dispatch]);

  useEffect(
    () => () => {
      dispatch(removeDimensions(key));
    },
    [key, dispatch],
  );

  return { ref, dimensions, onLayout };
};

export default useViewDimensions;
